function init_orgy(from_php){
    var main=$(".place.orgy");
    var girlAll=from_php.girls;
    var girlCount=0;
    var sets_config=[
          {set_id:1,girls:["anya","maggie"],"have":0,"is_new":1,anim:{clips:12,width:142,height:210,left:1031,top:136}}
      ];

      var static_queue=["maggie","anya","twins","indira","twins","frecly","geeky","victoria","cherry",
          "zoe","ice","sanshi","ashley","dora","cindy","pantress","lola","emma","winona","linn","alice"];
      static_queue=[
          "winona","emma","linn","alice","lola","pantress","cindy","dora","ashley","sanshi","ice","zoe",
          "cherry","victoria","geeky","frecly","anya","maggie","twins","indira"
          ];

          function prepareStaticView(){
              var html="",i,girl_id,girl_name,k,row,imagePreload=[];
              for(i in static_queue){
                  girl_name=static_queue[i];
                  if(typeof girlAll[girl_name]!="undefined"){
                      for(k in sets_config){
                          row=sets_config[k];
                          if(in_array(girl_name,row.girls)){
                              row.have++;
                              if(intval(girlAll[girl_name].orgy_seen)){
                                  row.is_new=0;
                              }
                          }
                      }
                      html+=
                          '<div class="girlWrap girlCell" data-name="'+girl_name+'"></div>'+
                          '<div class="girlWrap eye" data-name="'+girl_name+'" data-step="0"></div>';
                      imagePreload.push(_IMG_SERV+"/gfx/place/orgy/easter/static/"+girl_name+"/ready/girl.png");
                      imagePreload.push(_IMG_SERV+"/gfx/place/orgy/easter/static/"+girl_name+"/ready/eye1.png");
                      imagePreload.push(_IMG_SERV+"/gfx/place/orgy/easter/static/"+girl_name+"/ready/eye2.png");
                      girlCount++;
                  }
              }

              var girlBox=main.find("#allGirls");
              girlBox.html(html);

              if(girlBox.find(".girlWrap.girlCell[data-name='twins']").length){
                  var nextGirl=girlBox.find(".girlWrap.eye[data-name='indira']");
                  if(nextGirl.length==0){
                      nextGirl=girlBox.find(".girlWrap.girlCell[data-name='twins']");
                  }
                  nextGirl.after('<div class="girlWrap girlCell girl2" data-name="twins"></div>');
              }
              if(girlBox.find(".girlWrap.girlCell[data-name='alice']").length) {
                var whereAddArm;
                if(girlBox.find(".girlWrap.girlCell[data-name='linn']").length) {
                  whereAddArm = girlBox.find(".girlWrap.arm[data-name='linn']");
                }

                if(whereAddArm){
                  whereAddArm.before('<div class="girlWrap arm" data-name="alice"></div>');
                }
              }
              if(imagePreload.length){
                  $("<div/>").one("myload",function(){
                      girlBox.find(".girlWrap.eye").each(function(){
                         $(this).myEye({});
                      });
                  }).myLoad(imagePreload);
              }
          }
          function prepareSets(){
              var i,row,html="";
              for(i in sets_config){
                  row=sets_config[i];
                  if(row.have==row.girls.length){
                      html+='<div class="cellSet" data-set_id="'+row.set_id+'" data-is_new="'+row.is_new+'"></div>';
                  }
              }
              var girlSet=main.find("#allSets");
              girlSet.html(html);
              girlSet.find(".cellSet").one("click",function(){
                  var th=$(this),set_id=intval(th.attr("data-set_id")),conf,i;
                  for(i in sets_config){
                      if(sets_config[i].set_id==set_id){
                          conf=sets_config[i];
                          break;
                      }
                  }
                  var img_name="set"+set_id,img_arr={},anim_conf=copyObj(conf.anim),html_arr=[],girl_ids=[],girl_name;
                  img_arr[img_name]=_IMG_SERV+"/gfx/place/orgy/easter/dynamic/"+set_id+".png";
                  for(i in conf.girls){
                      girl_name=conf.girls[i];
                      girl_ids.push(girlAll[girl_name].girl_id);
                      html_arr.push(".girlWrap[data-name='"+girl_name+"']");
                  }
                  main.find(".girlWrap[data-name='"+girl_name+"']").eq(0).after('<canvas class="girlCanvas" data-set_id="'+set_id+'" width="1280" height="780"></canvas>');
                  var canvObj=main.find(".girlCanvas[data-set_id='"+set_id+"']");

                  var canvDuration=mt_rand(40,60);
                  canvObj.startOrgyAnim({width:1280,heigth:780,period:canvDuration},_moduleTimeHandler);
                  //<canvas class="girlCanvas" width="1280" height="780"></canvas>
                  canvObj.startOrgyAnim("addAnimImages",img_arr);
                  var fadeOutHowlong=1000;
                  main.find(html_arr.join(",")).fadeOut(fadeOutHowlong);
                  _moduleTimeHandler.addOne(function(){
                      anim_conf.step_fade_in=Math.round(fadeOutHowlong/canvDuration);
                      canvObj.startOrgyAnim("addAnimClipCustom",img_arr,anim_conf);
                  },fadeOutHowlong);
                  $.mypost('/ajax',{page:"orgy","girls_orgy":girl_ids.join(",")},function(){},"json");
                  th.hide();
              });
              _moduleTimeHandler.setOne(_moduleTimeHandler.getNewIndex(),function () {
                girlSet.find(".cellSet").trigger("click");
              },1000)
              // girlSet.find(".cellSet[data-is_new='1']").each(function(){
              //    var th=$(this);
              //     th.append("<div class='arrowView green'></div>");
              //     th.find(".arrowView").myUpDown({left:(th.width()/2-30),top:0,rotation:180});
              // });
          }
          prepareStaticView();
          prepareSets();
          if(girlCount<3){
              main.append("<div id='rabitNone'></div>");
              main.find("#rabitNone").click(function(){
                  $.goToLocation("gameninja")
              }).qAnim({width:320, clips:6,
                        interval:80,
                        loop:1}
              );
        }

    var loader = new PIXI.loaders.Loader();

    bunnyAnim = function(resourcesAll) {
      this.app=new PIXI.Application({
          width: 565, height: 400,transparent:true,antialias: true,
          view:main.find("#bunnyOrgy")[0]
      });
      this.resources = resourcesAll;
      var conf = {
        spine_conf:{
          // updateAnim:true,
          anim_loop:true,
          spineResource:this.resources
        },
        img:"bunny"
      };
      this.spineContainer = new myPixiElement.spine(conf);
      this.played = false;
    }
    bunnyAnim.prototype = $.extend(bunnyAnim.prototype,{
      addAnim:function () {
        this.spineContainer.scale.set(0.5,0.5);
        this.spineContainer.x = 250;
        this.spineContainer.y = 240;
        this.app.stage.addChild(this.spineContainer);
      },
      addCover:function () {
        var conf = {
          img:"tableClover"
        };
        this.cover = new myPixiElement.img(conf);
        this.cover.width = 593;
        this.cover.height = 153;
        this.cover.y = 327;
        this.cover.x = 274;
        this.app.stage.addChild(this.cover);
      },
      playAnim:function () {
        if(this.played) {
          return false;
        }
        this.played=true;
        this.addCover();
        this.addAnim();
        main.find('#bunnyOrgy').fadeIn();
      },
      remove:function () {
        this.spineContainer.myRemove();
      }
    });
    loader.add("bunny",_IMG_SERV+"/gfx/place/orgy/easter/dynamic/bunny/coneja.json");
    loader.add("tableClover",_IMG_SERV+"/gfx/place/orgy/easter/back/backCover.jpg");
    loader.load(function(loader, resources){
        if(from_php.isShowAnim){
          animBunny = new bunnyAnim(resources);
          animBunny.playAnim();
        }
    });
}
